export default __webpack_public_path__ + "images/polyfactory_3087ca.png";